export function formatBytes(bytes: number): string {
  if (!bytes) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, i)).toFixed(i === 0 ? 0 : 2)} ${units[i]}`;
}

export function pct(used: number, limit: number): number {
  if (!limit) return 0;
  return Math.min(100, Math.round((used / limit) * 100));
}

// Share of a part over a total (0-100), clamped.
export function share(part: number, total: number): number {
  if (!total) return 0;
  return Math.min(100, Math.round((part / total) * 100));
}

export interface UsageTone {
  // SVG/CSS color for strokes and fills
  color: string;
  // Tailwind text/background helper classes for horizontal bars
  text: string;
  bg: string;
}

// Threshold semaphore: <60% healthy, 60-80% warning, >=80% critical.
export function usageTone(value: number): UsageTone {
  if (value >= 80) {
    return {
      color: 'hsl(var(--destructive))',
      text: 'text-destructive',
      bg: 'bg-destructive',
    };
  }
  if (value >= 60) {
    return {
      color: 'hsl(var(--warning))',
      text: 'text-warning',
      bg: 'bg-warning',
    };
  }
  return {
    color: 'hsl(var(--success))',
    text: 'text-success',
    bg: 'bg-success',
  };
}
